function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Button from "../../basic/Button/Button.js";
var CallsToAction = _ref => {
  var {
    primaryAction,
    secondaryAction
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, secondaryAction && /*#__PURE__*/React.createElement(Button, _extends({
    monochrome: true,
    size: "small",
    variant: "text"
  }, secondaryAction), secondaryAction.text), /*#__PURE__*/React.createElement(Button, _extends({
    monochrome: true,
    size: "small",
    variant: "secondary"
  }, primaryAction), primaryAction.text));
};
export default CallsToAction;